import {
  createStyles,
  Divider,
  List,
  Theme,
  WithStyles,
  withStyles,
  Grid,
  ButtonBase,
  CardHeader,
  CssBaseline,
  CardContent,
  MenuItem,
} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import * as React from "react";
import SimpleListMenu from "./SimpleListMenu";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import QuestionItemComponent from "./QuestionItemComponent";
import { isEmpty, ORITATIONS } from "../constants/constants";
import imagePlacholder from "../assets/images/image-placeholder.png";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 10,
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    card: {
      width: 400,
    },
    listSection: {
      backgroundColor: "inherit",
    },
    img: {
      marginLeft: 20,
      display: "block",
      maxWidth: "100%",
      maxHeight: "100%",
    },
    image: {
      width: 150,
      height: 150,
    },
    margin: {
      margin: theme.spacing(1),
    },
    cover: {
      width: 151,
      height: 151,
    },
    ul: {
      backgroundColor: "white",
      padding: 0,
    },
    content: {
      flex: "1 0 auto",
    },
    details: {
      display: "flex",
      flexDirection: "column",
    },
    media: {
      height: 140,
    },
    typography: {
      padding: theme.spacing(2),
    },
  });
//   companyData: any;
//   onClick: any;
//   onUpdatePage: any;

interface Props extends WithStyles<typeof styles> {
  inspectionData: any;
  editData: any;
  key: any;
  index: any;
  onEdit: any;
  onDelete: any;
  connectDragSource?: any;
}
class InspectionCardComponent extends React.Component<Props> {
  state = {
    openAddCompanyDialog: false,
    openManageUsersDialog: false,
    openConfirmationDialog: false,
    isSuccess: false,
    base64: "",
    isError: false,
    open: false,
  };
  onMenuOpen = () => {
    this.setState({ open: true });
  };

  handleMenuItemClick = (event: any, index: any) => {
    switch (index) {
      case 0:
        this.props.onEdit(
          this.props.inspectionData,
          this.state.base64,
          this.props.index
        );
        break;
      case 1:
        this.props.onDelete(
          this.props.inspectionData,
          this.state.base64,
          this.props.index
        );
        break;
      default: {
        console.log("Oops something happen.");
      }
    }
  };
  getMenuOptions = () => {
    let options = [
      {
        title: "Edit",
        icon: <EditIcon fontSize="small" style={{ marginRight: 10 }} />,
      },
      {
        title: "Delete",
        icon: <DeleteIcon fontSize="small" style={{ marginRight: 10 }} />,
      },
    ];
    return options;
  };
  renderMenuItem = (
    option: any,
    index: any,
    selectedIndex: any,
    onClose: Function
  ) => {
    return (
      <MenuItem
        key={option.title}
        selected={index === selectedIndex}
        onClick={(event) => {
          onClose();
          this.handleMenuItemClick(event, index);
        }}
      >
        {option.icon}
        {option.title}
      </MenuItem>
    );
  };
  render() {
    const { classes, inspectionData, editData, key } = this.props;
    return (
      <React.Fragment key={key}>
        <CssBaseline />
        <Card className={classes.root}>
          <CardHeader
            title={inspectionData.title}
            titleTypographyProps={{ variant: "subtitle1" }}
            action={
              <SimpleListMenu
                oritation={ORITATIONS.VERTICAL}
                options={this.getMenuOptions()}
                renderItem={this.renderMenuItem}
              />
            }
          />
          <Divider />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item>
                <ButtonBase className={classes.image}>
                  {editData && !isEmpty(editData) ? (
                    <img
                      className={classes.img}
                      alt="complex"
                      src={`data:image/jpeg;base64,${editData.base64}`}
                    />
                  ) : inspectionData.base64 ? (
                    <img
                      className={classes.img}
                      alt="complex"
                      src={`data:image/jpeg;base64,${inspectionData.base64}`}
                    />
                  ) : this.state.base64 ? (
                    <img
                      className={classes.img}
                      alt="complex"
                      src={`data:image/jpeg;base64,${this.state.base64}`}
                    />
                  ) : (
                    <img
                      className={classes.img}
                      alt="complex"
                      src={imagePlacholder}
                    />
                  )}
                </ButtonBase>
              </Grid>
              <Grid item xs={12} sm container>
                <List
                  dense={true}
                  style={{
                    width: "100%",
                    height: 200,
                    overflow: "auto",
                  }}
                >
                  {editData && !isEmpty(editData)
                    ? editData.questions.map((question: any, index: any) => (
                        <React.Fragment key={index.toString()}>
                          <QuestionItemComponent
                            questionItem={question}
                            itemKey={index}
                          />
                        </React.Fragment>
                      ))
                    : inspectionData.questions.map(
                        (question: any, index: any) => (
                          <React.Fragment key={index.toString()}>
                            <QuestionItemComponent
                              questionItem={question}
                              itemKey={index}
                            />
                          </React.Fragment>
                        )
                      )}
                </List>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(InspectionCardComponent);
